import type { SessionOptions } from 'iron-session'

import { cookieName } from './types.ts'

export const options: SessionOptions = {
  password: process.env.PRINCIPAL_SESSION_KEY ?? 'n/a',
  cookieName,
  cookieOptions: {
    secure: process.env.NODE_ENV === 'production',
  },
}
